import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import PWAInstallButton from './PWAInstallButton';
import { canonicalOrigin } from '../lib/canonicalOrigin';

/**
 * Install-URL — nutzt IMMER die kanonische Produktions-Domain (fuelxcard.com),
 * damit QR-Codes und Install-Links unabhängig von Preview vs. Production
 * konsistent auf dem echten Zielsystem landen. Verhindert den PWA-Install-Bug,
 * bei dem die App vor Kurzem noch die Preview-URL persistierte.
 */
export function installUrl() {
  return `${canonicalOrigin()}/?install=1`;
}

/**
 * AppInstallCard — prominente dunkle Karte „Die App aufs Handy — mit einem Klick."
 * QR-Code führt auf ?install=1 → öffnet auf dem Handy direkt den 1-Tap-Install-Screen.
 */
export default function AppInstallCard({ testId = 'app-install-card', className = '' }) {
  return (
    <div className={`rounded-3xl bg-stone-950 border border-stone-800 relative overflow-hidden p-8 sm:p-10 ${className}`} data-testid={testId}>
      <div
        className="absolute -top-24 -right-16 w-72 h-72 rounded-full opacity-30 blur-3xl pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(62,255,126,0.45) 0%, transparent 70%)' }}
        aria-hidden="true"
      />
      <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-7">
        <img src="/apple-touch-icon.png" alt="FUEL.X App" width="180" height="180" className="w-16 h-16 rounded-2xl border border-white/15 flex-shrink-0" loading="lazy" decoding="async" />
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-emerald-300 mb-2">FUEL.X App</p>
          <h3 className="font-display text-white text-2xl sm:text-3xl tracking-[-0.02em] leading-tight">
            Die App aufs Handy — <span className="text-emerald-400">mit einem Klick.</span>
          </h3>
          <p className="text-sm text-stone-400 leading-relaxed mt-2 max-w-md">
            Kein App Store, kein Umweg: FUEL.X direkt installieren — Konfigurator, Buchungen und Wallet immer griffbereit.
          </p>
          <PWAInstallButton variant="primary" label="App jetzt installieren" testId={`${testId}-install-btn`} className="mt-5" />
        </div>
        <div className="hidden lg:flex flex-col items-center gap-2 flex-shrink-0" data-testid={`${testId}-qr`}>
          <div className="bg-white rounded-xl p-2.5">
            <QRCodeSVG value={installUrl()} size={104} level="M" title="QR-Code — FUEL.X App auf dem Handy installieren" aria-label="QR-Code — FUEL.X App auf dem Handy installieren" />
          </div>
          <p className="text-[10px] text-stone-500 uppercase tracking-[0.18em]">Mit dem Handy scannen</p>
        </div>
      </div>
    </div>
  );
}
